import { useCallback, useContext } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { setDirty } from '../actions';
import LastEditedContext from '../contexts/LastEditedContext';
import LockContext from '../contexts/LockContext';
import UuidContext from '../contexts/UuidContext';
import api from '../utils/api';

let updating = false;

export function useDirty() {
  const dispatch = useDispatch();
  const dirty = useSelector(state => state.dirty)
  const { uuid } = useContext(UuidContext);
  const { lock, setLock } = useContext(LockContext);
  const { lastEdited } = useContext(LastEditedContext);

  return useCallback((successCb, catchCb) => {

    // Prevent multiple calls in a row
    if (updating) {
      return;
    }

    if (!dirty && lastEdited && !lock.owner) {

      updating = true;

      api.lockIntv(uuid,lastEdited)
        .then(res => {
          setLock({
            id: res.data.id,
            owner: res.data.user,
            ownerEmail: res.data.lockOwnerEmail,
            isCurrent: true,
          })

          if (successCb) {
            successCb(res.data.id)
          }

          dispatch(setDirty())

        })
        .catch(err => {
          let message = 'An error occurred. This item was not locked for edits.';
          let lockInfo = {};

          switch (err.response.status) {
            case 409:
              // Someone else edited and saved in the meantime
              message = 'This item has changed. Refresh to get the latest data.';
              lockInfo = err.response.data.errors;
              setLock({
                refresh: true,
              })
              break;
            case 423:
              // Someone else edited in the meantime
              message = 'This item is already locked for edits. Your changes will not be saved';
              lockInfo = err.response.data.errors;
              setLock({
                id: lockInfo.LockId,
                owner: lockInfo.LockOwner,
                ownerEmail: lockInfo.LockOwnerEmail,
                newlyLocked: true,
              })
              break;
            case 500:
              message = 'An internal server error occurred. This item may not have been locked for edits.';
              break;
            default:
              break;
          }

          console.log(message)

          /**
           * @todo
           * Set notification with message?
           * Would need to make notification store or context
           */

          if (catchCb) {
            catchCb()
          }
        })
        .finally(() => {
          updating = false;
        });

    } else if (!dirty) {
      dispatch(setDirty())      
    }

  },[dispatch,dirty,uuid,setLock,lastEdited,lock.owner])
}